import axios from "axios";
import { getHeaderConfig } from "utility/HeaderConfig";
import { BASE_URL } from "utility/UrlConstants";

const getAllTax = (searchValue: Object) => {
  return axios
    .get(
      `${BASE_URL}/admin/accounts/tax/metadata/get-all?metaTaxationFilter=${JSON.stringify(
        searchValue
      )}`,
      getHeaderConfig()
    )
    .then(response => {
      const respData = {
        responseCode: response.status,
        response: response.data
      };
      return respData;
    })
    .catch(error => {
      console.log(error);
      throw error;
    });
};

const getAllFloor = () => {
  return axios
    .get(`${BASE_URL}/admin/location/floor/get-all`, getHeaderConfig())
    .then(response => {
      const respData = {
        responseCode: response.status,
        response: response.data
      };
      return respData;
    })
    .catch(error => {
      console.log(error);
      throw error;
    });
};

const getAllSection = (filters: Object) => {
  return axios
    .get(`${BASE_URL}/admin/location/section/get-all?filters=${JSON.stringify(filters)}`, getHeaderConfig())
    .then(response => {
      const respData = {
        responseCode: response.status,
        response: response.data
      };
      return respData;
    })
    .catch(error => {
      console.log(error);
      throw error;
    });
};


export {
    getAllTax,
    getAllFloor,
    getAllSection
}